import { useCurrentUser } from '@/hooks/useCurrentUser'
import { useRole } from '@/hooks/useRole'
import { ClerkUserRole } from '@/types/auth'

export type CoachingManagement = {
  /** False until the role, and for a coach or super admin `/users/me`, has resolved. */
  readonly isLoaded: boolean
  readonly canManageCoaching: boolean
}

/** Roles that `/users/me` can report as coaching managers. */
const MANAGER_ROLES: ReadonlySet<ClerkUserRole> = new Set([ClerkUserRole.COACH, ClerkUserRole.SUPER_ADMIN])

/**
 * Whether the viewer gets the coaching portal manager tools: a coach or super admin with the coaching manager flag.
 * The only frontend source for that answer. Not an authorization check: the API decides.
 */
export function useCanManageCoaching(): CoachingManagement {
  const { userRole, isLoaded: roleLoaded } = useRole()
  const { user, isLoading } = useCurrentUser()

  if (!roleLoaded) return { isLoaded: false, canManageCoaching: false }
  if (!userRole || !MANAGER_ROLES.has(userRole)) return { isLoaded: true, canManageCoaching: false }

  return { isLoaded: !isLoading, canManageCoaching: user?.can_manage_coaching === true }
}
